import EventEmitter from "base/EventEmitter";
import RangeInput from "../util/RangeInput";

export default class ProductFilters extends EventEmitter {

    constructor($element, manager) {
        super();

        this.$element = $element;
        this.manager = manager;
        this.name = this.$element.attr('data-name');

        this.ranges = {};
        this.buildRanges();

        this.filters = {};
        this.starting_filters = {};

        this.bindEvents();
        this.updateStartingValues();
        this.updateLatestFilters();
    }

    updateStartingValues() {
        this.starting_filters = this.getLatestFilters();
    }

    buildRanges() {
        this.ranges = RangeInput.apply(this.$element);
        this.rangesMap = {};

        if (this.ranges.length <= 0) {
            return;
        }

        this.ranges.forEach((range) => {
            range.on("change", () => {
                this.updateLatestFilters();
            });

            this.rangesMap[range.getName()] = range;
        });
    }

    updateLatestFilters() {
        this.filters = this.getLatestFilters();
        this.updateClearButton();
        this.updateChangeNotifications();
        this.updateParentLink();
    }

    updateParentLink() {
        let text = '';
        let count = this.getNumberOfAppliedFilters();

        if (count > 0) {
            text = count + ' applied';
        }

        this.manager.$element.find('.filter-link[data-name="' + this.name + '"').find('.filter-link__number').text(text);
    }

    getNumberOfAppliedFilters() {
        let count = 0;

        Object.keys(this.filters).forEach((index) => {
            if (Object.keys(this.rangesMap).indexOf(index) !== -1) {
                let value = this.rangesMap[index].getValue();
                if (value.min !== this.rangesMap[index].getMinimumValue() || value.max !== this.rangesMap[index].getMaximumValue()) {
                    count++;
                }
            } else {
                count++;
            }
        });

        return count;
    }

    updateClearButton() {
        if (this.getNumberOfAppliedFilters() > 0) {
            this.$element.find('.filter-section').addClass('has-values');
        } else {
            this.$element.find('.filter-section').removeClass('has-values');
        }
    }

    getUpdatedFields() {
        let updated_fields = {};

        Object.keys(this.filters).forEach((key) => {

            if ('undefined' === typeof this.starting_filters[key]) {
                updated_fields[key] = true;
                return;
            }

            if (this.filters[key].length !== this.starting_filters[key].length) {
                updated_fields[key] = true;
                return;
            }

            if (Object.keys(this.rangesMap).indexOf(key) !== -1) {
                let value = this.rangesMap[key].getValue();

                if (value.min !== this.starting_filters[key].min || value.max !== this.starting_filters[key].max) {
                    updated_fields[key] = true;
                    return;
                }
            }

            Object.values(this.filters[key]).forEach((value) => {
                if (this.filters[key] instanceof Object) {
                    return;
                }

                if (this.starting_filters[key].indexOf(value) === -1) {
                    updated_fields[key] = true;
                    return;
                }
            });
        });

        Object.keys(this.starting_filters).forEach((key) => {
            if ('undefined' === typeof this.filters[key]) {
                updated_fields[key] = true;
                return;
            }
        });

        return updated_fields;
    }

    updateChangeNotifications() {
        let updated_fields = this.getUpdatedFields();

        this.$element.find('.js-accordion-item').removeClass('has-changes');
        Object.keys(updated_fields).forEach((key) => {
            this.$element.find('.js-accordion-item[data-name="' + key + '"]').addClass('has-changes');
        });
    }

    getLatestFilters() {
        let filters = {};

        this.$element.find(".js-filter-value:checked").each((_, el) => {
            let $el = $(el);
            let name = $el.attr("data-name");

            if ('undefined' === typeof filters[name]) {
                filters[name] = [];
            }

            filters[name].push($el.attr("value"));
        });

        this.ranges.forEach((range) => {
            let values = range.getValue();
            if (values.min !== range.getMinimumValue() || values.max !== range.getMaximumValue()) {
                filters[range.$input.attr('name')] = values;
            }
        });

        return filters;
    }

    bindEvents() {
        let me = this;

        this.$element.on('change', '.js-filter-value', () => {
            this.updateLatestFilters();
            return false;
        }).on('click', '.js-apply', () => {
            this.updateLatestFilters();
            this.manager.updateFilters();
            this.manager.showView('main');
            return false;
        }).on('click', '.js-show-results', () => {
            this.updateLatestFilters();
            this.manager.updateResults();
            return false;
        }).on('click', '.js-clear', () => {
            this.clear();
            return false;
        });
    }

    clear() {
        this.$element.find(".js-filter-value:checkbox").prop('checked', false);

        this.ranges.forEach((range) => {
            range.clear();
        });

        this.updateLatestFilters();
    }
}